import type { departments as en } from '@/i18n/locales/en/departments';
import type { Translation } from '@/i18n/types';

export const departments: Translation<typeof en> = {
  page: {
    title: 'Τμήματα',
    leadPersonal: 'Τμήματα των οποίων είστε μέλος.',
    leadCompany: 'Τμήματα στην {{company}}.',
  },
  list: {
    cardTitle: 'Τμήματα',
    name: 'Όνομα',
    company: 'Εταιρεία',
    statistics: 'Στατιστικά',
    collectiveConsent: 'Συλλογική συγκατάθεση',
    inForce: 'σε ισχύ',
    none: '—',
    unattached: 'χωρίς σύνδεση',
    empty: 'Δεν υπάρχουν ακόμη τμήματα εδώ.',
    newDepartment: 'Νέο τμήμα',
  },
  compare: {
    cardTitle: 'Σύγκριση τμημάτων',
    pageTitle: 'Σύγκριση τμημάτων',
    lead: 'Σύγκριση των τμημάτων των οποίων τα στατιστικά μπορείτε να δείτε.',
    empty: 'Κανένα τμήμα εδώ δεν έχει στατιστικά που μπορείτε να δείτε.',
  },
  detail: {
    thisDepartment: 'τμήμα',
    edit: 'Επεξεργασία',
    setVisibility: 'Ορισμός ορατότητας',
    collectiveConsent: 'Συλλογική συγκατάθεση',
    coach: 'Προπονητής',
    category: 'Κατηγορία',
    type: 'Τύπος',
    statistics: 'Στατιστικά',
    notRecorded: 'δεν καταγράφηκε',
    membersCardTitle: 'Μέλη',
    statsCardTitle: 'Στατιστικά',
    settingsCardTitle: 'Ρυθμίσεις',
    addPerson: 'Προσθήκη ατόμου',
    name: 'Όνομα',
    nickname: 'Ψευδώνυμο',
    login: 'Σύνδεση',
    yes: 'ναι',
    no: 'όχι',
    noMembers: 'Δεν υπάρχουν μέλη.',
  },
  form: {
    newTitle: 'Νέο τμήμα',
    newLead:
      'Κάθε νέο τμήμα ξεκινά μόνο με συγκεντρωτικά στοιχεία — η κατάσταση που προστατεύει την ιδιωτικότητα είναι αυτή που έχετε χωρίς να κάνετε τίποτα.',
    name: 'Όνομα',
    category: 'Κατηγορία',
    type: 'Τύπος',
    cancel: 'Ακύρωση',
    create: 'Δημιουργία τμήματος',
    editTitle: 'Επεξεργασία τμήματος',
    save: 'Αποθήκευση',
    deleteCardTitle: 'Διαγραφή',
    deleteButton: 'Διαγραφή αυτού του τμήματος',
    deleteConfirm: 'Οριστική διαγραφή του {{name}};',
    deleteKeep: 'Διατήρηση',
    deleteYes: 'Ναι, διαγραφή',
    visibilityTitle: 'Ορατότητα στατιστικών',
    visibilityLead:
      'Το «ατομικό» δεν εκθέτει από μόνο του κανέναν: επιτρέπει ατομική πρόσβαση όπου μια βάση συγκατάθεσης καλύπτει το μέλος. Η μετάβαση σε ατομικό χωρίς συλλογική εγγραφή δημιουργεί μια εκκρεμή εγγραφή συγκατάθεσης για κάθε τρέχον μέλος.',
    visibilityAggregate: 'συγκεντρωτικό — μόνο αριθμοί ομάδας',
    visibilityIndividual: 'ατομικό — πρόσβαση ανά μέλος όπου το καλύπτει η συγκατάθεση',
    collectiveConsentTitle: 'Βάση συλλογικής συγκατάθεσης',
    collectiveConsentLead:
      'Όσο ισχύει μια συλλογική εγγραφή, καλύπτει όλα τα μέλη του {{name}}, ανεξάρτητα από την προσωπική τους απάντηση. Οι δικές τους εγγραφές διατηρούνται και ισχύουν ξανά όταν ανακληθεί.',
    collectiveConsentNote: 'Συμφωνία εκτός πλατφόρμας (προσδιορίστε την με ακρίβεια)',
    collectiveConsentRecord: 'Καταγραφή συλλογικής βάσης',
    revokeCardTitle: 'Ανάκληση',
    revokeButton: 'Ανάκληση της συλλογικής βάσης',
  },
};
